// extracted by css-extract-rspack-plugin
module.exports =  {"calWrapper":"QfZRO","calBorder":"CsN5T"};